import { PPIconLink } from 'processor-plataform-ui';
import React, { CSSProperties, useEffect } from 'react';
import { Context, NotificationCenterService } from '../../../../services/notificationCenter/notificationService';

import './index.css'

interface Props {
    createdBy?: string,
    createdOn?: string,
    pinned?: boolean,
    context?: Context,
    sendEmail?: boolean,
}

const CreatedCard: React.FC<Props> = (props) => {

    const notificationService = new NotificationCenterService(props);

    const bellStyle: CSSProperties = {
        fontSize: '24px',
        marginLeft: '0.5rem'
    }

    const iconsStyle: CSSProperties = {
        display: 'flex',
        flexDirection: 'row'
    }

    return (
        <span className={`cardFromSendNotification`}>
            {props &&
                <>
                    <span className='dateCard'>
                        <small>Criado por {props.createdBy}</small>
                        <small>Criado em {notificationService.FormatDate(props.createdOn as string)}</small>
                    </span>
                    <span style={iconsStyle}>
                        {
                            props.pinned &&
                            <i className={`ppi ppi-pin`} style={bellStyle} />
                        }
                        <i className={`ppi ppi-bell colorBell-${props.context}`} style={bellStyle} />
                        {
                            props.sendEmail &&
                            <i className={`ppi ppi-mail`} style={bellStyle}></i>
                        }
                    </span>
                </>
            }
        </span>
    );
}

export default CreatedCard;